import { supplierApi } from "../../api";

const SupplierService = {
  /**
   * Obtiene todos los proveedores con paginación.
   * GET /api/suppliers/list?page=0&size=10
   */
  getAllPaged: async (page: number, size: number) => {
    try {
      const response = await supplierApi.fetchCustom(`/list?page=${page}&size=${size}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Obtiene una lista paginada de proveedores filtrados.
   * POST /api/suppliers/filtered?page=X&size=Y&sort=campo,asc|desc
   */
  getFiltered: async (
    filter: any,
    page = 0,
    size = 10,
    sort = "name,asc"
  ) => {
    try {
      const response = await supplierApi.addCustom(
        `/filtered?page=${page}&size=${size}&sort=${sort}`,
        filter
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Obtiene proveedores en formato dropdown.
   * GET /api/suppliers/dropdown
   */
  getDropdown: async () => {
    try {
      const response = await supplierApi.fetchCustom("/dropdown");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Obtiene un proveedor por ID.
   * GET /api/suppliers/{id}
   */
  getById: async (id: number) => {
    try {
      const response = await supplierApi.fetchCustom(`/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Obtiene un proveedor por ID para Editar.
   * GET /api/suppliers/edit/{id}
   */
  getSupplierForEdit: async (id: number) => {
    try {
      const response = await supplierApi.fetchCustom(`/edit/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Crea un nuevo proveedor.
   * POST /api/suppliers
   */
  add: async (data: Object) => {
    try {
      const response = await supplierApi.add(data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Actualiza un proveedor por ID.
   * PUT /api/suppliers/{id}
   */
  modify: async (id: number, data: Object) => {
    try {
      const response = await supplierApi.modify(id, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Busca un proveedor por NIT o NRC (para importar compras desde un DTE).
   * GET /api/suppliers/match?nit=&nrc=  →  data = SupplierEditDTO | null
   */
  matchByNitOrNrc: async (nit?: string | null, nrc?: string | null) => {
    const query = new URLSearchParams();
    if (nit) query.set('nit', nit);
    if (nrc) query.set('nrc', nrc);
    const response = await supplierApi.fetchCustom(
      `/match?${query.toString()}`
    );
    return response.data;
  },

  /**
   * Registra un proveedor de un clic con los datos del emisor de un DTE.
   * POST /api/suppliers/quick-from-dte  →  data = SupplierEditDTO (creado o existente)
   */
  quickRegisterFromDte: async (payload: {
    nit: string;
    nrc: string;
    name: string;
    tradeName: string;
    phone: string;
    email: string;
    departmentCode: string;
    municipalityCode: string;
    address: string;
    economicActivityCode: string;
  }) => {
    const response = await supplierApi.addCustom('/quick-from-dte', payload);
    return response.data;
  },

  /**
   * Cambia el estado de un proveedor (activo/inactivo).
   * PATCH /api/suppliers/{id}/toggle-status
   */
  toggleStatus: async (id: number) => {
    try {
      const response = await supplierApi.patchCustom(`${id}/toggle-status`);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default SupplierService;
